import React from 'react';
import './Alert.css';

const propTypes = {
  corner: React.PropTypes.string,
  isImportant: React.PropTypes.bool
}

const Alert = props => (
  <div className={`alert ${props.isImportant ? 'alert--important' : ''} ${props.corner ? 'alert--corner-' + props.corner : ''}`}>
    {props.children}
  </div>
)

Alert.propTypes = propTypes;

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js